import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'user-infos',
  standalone: false,
  templateUrl: './user-infos.component.html',
  styleUrl: './user-infos.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserInfosComponent {
  fullName = input.required<string>();
  username = input.required<string>();
}
